export default __webpack_public_path__ + "static/logo-c84d400ec1bbd7f3b3049655ccfafd19.svg";